import { CalendarEventType } from '@/types/Calendar.ts'

export enum MealType {
    breakfast = 'breakfast',
    lunch = 'lunch',
    snack = 'snack',
    dinner = 'dinner'
}

export type MealMenu = {
    id: number
    daycareId: number
    menu: string
}

export type MealTexture = {
    id: number
    daycareId: number
    texture: string
}

export type MealHabit = {
    id: number
    daycareId: number
    habit: string
}

export type MealAccessibilitySection = {
    id: number
    daycareId: number
    sectionId: number
    sectionName: string
    start: Date
    type: MealType
}

export type MealChild = {
    childId: number
    firstname: string
    complement: string | null
    sectionId: number
    sectionName: string
    start: string
    end: string
    slotType: CalendarEventType
    menus: MealMenu[]
    textures: MealTexture[]
    habits: MealHabit[]
}

export type MealChildWithoutMenu = {
    childId: number
    firstname: string
    complement: string | null
    sectionId: number
    sectionName: string
    start: string
    end: string
    slotType: CalendarEventType
}

export type MealDetail = {
    quantityAdded: number
    quantityReserved: MealQuantityChild[]
    quantityReal: MealQuantityChild[]
    combination: MealDetailCombination
}

export type MealQuantityChild = {
    childId: number
    firstname: string
}

type MealDetailCombination = {
    menus: MealMenu[]
    textures: MealTexture[]
    habits: MealHabit[]
}

export type MealTypeDetail = {
    type: MealType
    sectionId: number
    sectionName: string
    frozen: boolean
    frozenDate: string | null
    details: MealDetail[]
    childs: MealChild[]
    childsWithoutMenu: MealChildWithoutMenu[]
}

export type MealDayDetailByType = {
    date: string
    closingDay: boolean
    typeDetails: MealTypeDetail[]
}
